<portal-form-select
  [clearable]="props.clearable || false"
  [compareWith]="compareFn"
  [disabled]="disabled"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [placeholder]="props.placeholder"
  [portalCyTest]="field.key"
  [searchable]="props.searchable || false"
>
  <ng-container
    [ngSwitch]="isObservableValue"
    select-display
  >
    <ng-container *ngSwitchCase="true">
      <ng-container *ngIf="props.options | formlySelectOptions: field | async as selectOptions">
        {{ getObsValue(selectOptions) }}
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>{{ renderViewValue(formControl.value) }}</ng-container>
  </ng-container>

  <ng-container
    *ngIf="props.options | formlySelectOptions: field | async as selectOptions"
    select-options
  >
    <ng-container *ngFor="let item of selectOptions">
      <portal-form-option
        *ngIf="!item.group"
        [disabled]="item.disabled || false"
        [highlightSelected]="props.highlightSelected ?? true"
        [value]="item.value"
      >
        {{ item.label }}
      </portal-form-option>
    </ng-container>
  </ng-container>
</portal-form-select>
